import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { DocumentsListPage } from '@/features/documents/documents-list-page'

const searchSchema = z.object({
  q: z.string().optional(),
  status: z.string().optional(),
  payment: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  branchId: z.string().optional(),
  customerId: z.string().optional(),
  page: z.number().int().min(1).optional(),
})

export const Route = createFileRoute('/_app/invoices')({
  staticData: { crumb: 'Facturas' },
  validateSearch: searchSchema,
  component: Page,
})

function Page() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <DocumentsListPage
      kind="FE"
      title="Facturas electrónicas"
      description="Facturas emitidas, su estado ante Hacienda y lo que falta por cobrar."
      search={search}
      onSearch={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
    />
  )
}
